import { defineStore } from 'pinia'

export const useUxStore = defineStore({
  id: 'ux',
  state: () => ({ 
    isOpenMobileMenu: false,
    isOpenSearchBar: false,
    isOpenHeader: true,
    isOpenWelcomeModal: false,
    isOpenMenu: {}
  }),
  actions: {}
})
